// extracted by mini-css-extract-plugin
module.exports = {"container":"spedizione_container__EuahP","textHolder":"spedizione_textHolder__5QXpz","textPDHolder":"spedizione_textPDHolder__0i8qS"};